import { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import {
  getRecipeStart,
  resetRecipe,
} from "../../../../store/features/recipe/recipe-slice";
import { useAppDispatch, useAppSelector } from "../../../../store/config";
import {
  StyledMenu,
  StyledOutletLayout,
} from "../../../../components/common/styles";
import { DietHeader } from "../../DietHeader";

interface MenuItem {
  key: string;
  label: string;
  path: string;
  disabled?: boolean;
}

export const Recipe = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();

  const isNew: boolean = location.pathname.includes("/diet/add");
  const { recipeId } = useParams<{ recipeId: string }>();
  const { recipe } = useAppSelector((state) => state.recipe);

  const menuItems: MenuItem[] = [
    {
      key: "recipe-details",
      label: t("Recipe Details"),
      path: ``,
    },
    {
      key: "recipe-instructions",
      label: t("Recipe Instructions"),
      path: `recipe-instructions`,
      disabled: isNew,
    },
  ];
  const [currentTab, setCurrentTab] = useState<string>(menuItems[0].key);

  useEffect(() => {
    if (!isNew) {
      dispatch(getRecipeStart({ recipeId: recipeId || "" }));
    }
    return () => {
      dispatch(resetRecipe());
    };
  }, [dispatch, isNew, recipeId]);

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    if (currentPath) {
      const activeTab = menuItems.find(
        (item) => item.path === currentPath
      )?.key;
      activeTab ? setCurrentTab(activeTab) : setCurrentTab(menuItems[0].key);
    }
  }, [location.pathname, menuItems]);

  return (
    <>
      <DietHeader recipeName={recipe?.name} />

      <StyledMenu
        selectedKeys={[currentTab]}
        mode="horizontal"
        items={menuItems}
        onClick={(e) => {
          setCurrentTab(e.key);
          navigate(menuItems.find((item) => item.key === e.key)?.path || ``);
        }}
      />
      <StyledOutletLayout>
        <Outlet />
      </StyledOutletLayout>
    </>
  );
};
